/* ----------------------------------------------------------------------------------------------
   BARRA DE CATEGORIAS — deslizamiento
   ----------------------------------------------------------------------------------------------
   Dos cosas que la barra sola no resuelve cuando hay 12 categorias y no entran:

   1. Nadie sabe que se desliza. Un degradado en el borde donde todavia hay recorrido lo dice
      sin texto ni flechas.
   2. Si estas en "Gorros", la barra arranca en "VER TODO" y no ves donde estas parado.
      Al cargar, deja la categoria actual a la vista.

   Todo lo demas (el deslizamiento en si) lo hace el navegador: aca solo se lee el scroll.
--------------------------------------------------------------------------------------------- */
class FpCatNav extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('.fp-cat__viewport');
    if (!this.viewport) return;

    this.#marcarBordes();
    this.#mostrarActiva();

    // rAF y no un listener directo: el scroll dispara decenas de veces por gesto y aca
    // solo hace falta el estado final de cada cuadro.
    let pendiente = false;
    this.viewport.addEventListener(
      'scroll',
      () => {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(() => {
          pendiente = false;
          this.#marcarBordes();
        });
      },
      { passive: true }
    );

    // Si cambia el ancho, lo que antes desbordaba puede entrar (y al reves).
    this.observador = new ResizeObserver(() => this.#marcarBordes());
    this.observador.observe(this.viewport);
  }

  disconnectedCallback() {
    this.observador?.disconnect();
  }

  #marcarBordes() {
    const v = this.viewport;
    const resto = v.scrollWidth - v.clientWidth;
    // 2px de tolerancia: el scrollLeft es fraccionario y en el tope exacto daba falsos positivos.
    this.classList.toggle('hay-antes', v.scrollLeft > 2);
    this.classList.toggle('hay-despues', resto > 2 && v.scrollLeft < resto - 2);
  }

  #mostrarActiva() {
    const activa = this.querySelector('.fp-cat__link.is-active');
    if (!activa) return;
    const v = this.viewport;
    if (v.scrollWidth <= v.clientWidth) return;

    // Centrada, pero sin pasarse de los extremos. Sin animacion: al entrar a la pagina
    // una barra que se mueve sola se lee como un error, no como una ayuda.
    const centro = activa.offsetLeft + activa.offsetWidth / 2 - v.clientWidth / 2;
    v.scrollLeft = Math.max(0, Math.min(centro, v.scrollWidth - v.clientWidth));
  }
}

if (!customElements.get('fp-cat-nav')) customElements.define('fp-cat-nav', FpCatNav);
